import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll position on route changes.
 * SPAs do not scroll to top by default — clicking footer links while scrolled
 * down would otherwise land users at the bottom of the next page.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ block: "start" });
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
